import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, Button, TextField, useTheme, IconButton } from "@mui/material";
import BackButton from "../../../components/BackButton";
import ScrollBox from '../../../components/ScrollBox';
import ImageUpload from '../../../components/ImageUpload';
import LabelTxtFieldInfo from "../../../components/LabelTxtFieldInfo";
import BgBoxOld from "../../../components/BgBoxOld";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useAuthContext } from "../../../context/AuthContext";
import { customAlert, notify } from "../../../components/notify";
import route from "../../../utils/Routes";
import { useLocation, useNavigate } from "react-router-dom";
import { createSubCatServ, getSingleCatServ } from "../../../services/amtc-service";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { isNotEmpty } from "../../../utils/format";

function CreateSubCategory() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { catId, catName } = location.state || {};
  const { setLoadingScreen } = useAuthContext();
  const [selection, setSelection] = useState({ fileKey: "", fileUrl: "" });
  const [formErrors, setFormErrors] = useState({});
  const [specs, setSpecs] = useState([{
    catSpec: ""
  }])
  const { isLoading, isError, error, data: parCatData } = useQuery([QueryKey.singleCat, catId], () => getSingleCatServ(catId),
    {
      enabled: isNotEmpty(catId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    });

  useEffect(() => {
    if (!catId)
      navigate("/", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catId])

  useEffect(() => {
    if (!parCatData?.specsJs)
      return;
    setParSpecs(parCatData?.specsJs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parCatData]);



  useEffect(() => {
    setLoadingScreen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  function setParSpecs(parSpec) {
    let arr = [];
    for (const e of parSpec) {
      arr.push({ ...e, isParSpec: true })
    }
    setSpecs(arr);
  }

  function handleImgRemove() {
    setSelection({ fileKey: "", fileUrl: "" })
  };

  function handleOnUpload({ fileKey, fileUrl }) {
    setSelection({ fileKey, fileUrl })
  }
  //parentId, catName, catImage, specsArr, jwtUserId

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const filtSpec = specs.filter(i => i.isParSpec === false);
      const payload = { parentId: catId, catName: inputObject.catName, catImage: selection.fileKey, specsArr: [...filtSpec] }
      console.dir(payload);
      const { message } = await createSubCatServ(payload);
      notify("success", message);
      navigate(`${route.aSubcategory}/?catId=${catId}&catName=${parCatData?.catName}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  async function handleCancel() {
    navigate(`${route.aSubcategory}/?catId=${catId}&catName=${catName}`, { replace: true })
  }



  function validate(values) {
    const errors = {};

    if (!values.catName)
      errors.catName = "Subcategory Name is required!";

    return errors;
  };

  const handleSpecsValChange = (index, e) => {
    const { name: field, value } = e.target;
    const updatedSpecs = [...specs];
    updatedSpecs[index][field] = value;
    setSpecs(updatedSpecs);
  };


  function addSpecs() {
    setSpecs([
      ...specs,
      {
        catSpec: "",
        isParSpec: false
      }
    ]);
  };

  function removeSpecs(index) {
    const updatedSpecs = [...specs];
    updatedSpecs.splice(index, 1);
    setSpecs(updatedSpecs);
  };

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (
    <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
      <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
        <BackButton width={"20%"} />
        <Stack width={"60%"} alignItems={"center"}>
          <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create Subcategory </Typography>
        </Stack>
        <Stack width={"20%"} />
        <Box />
      </Stack>
      <BgBoxOld height={"93%"} py={1}>
        {parCatData && <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
          <ImageUpload currentImage={selection?.fileUrl} onUpload={handleOnUpload} onRemove={handleImgRemove} />
          <Box sx={{ width: "100%", height: "90%" }}>
            <Stack direction={"row"} alignItems={"center"} gap={10}>
              <LabelTxtFieldInfo name="parcatName" defaultValue={parCatData?.catName} readOnly={true} title="Category" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
              <LabelTxtFieldInfo name="catName" errMsg={formErrors.catName} title="Subcategory *" width={250} height={30} borderRadius={1} rows={1} />
            </Stack>

            <Stack direction={'row'} alignItems='center' mt={2} >
              <Typography sx={{ fontSize: 12, fontWeight: 500, color: "rgba(0, 0, 0, 0.8)" }}>Common Product Specification</Typography>
              <IconButton onClick={addSpecs}>
                <AddCircle sx={{ color: theme.palette.custom.btn }} />
              </IconButton>
            </Stack>
            <ScrollBox height={"60%"} width={"35%"}>
              {specs.map((i, index) => (
                <Stack key={index}>
                  {i?.isParSpec ? <Stack direction={"row"} alignItems={"center"} width={240} my={0.7}>
                    <TextField name="catSpec" InputProps={{ readOnly: true }} fullWidth size='small' value={i.catSpec}
                      sx={{ '& .MuiOutlinedInput-root': { fontSize: 12, height: 30, backgroundColor: "rgba(162, 214, 249, 0.18)" } }} />
                  </Stack> : <Stack direction={"row"} alignItems={"center"} width={280}>
                    <TextField name="catSpec" fullWidth size='small' value={i.catSpec} onChange={(e) => handleSpecsValChange(index, e)}
                      sx={{ '& .MuiOutlinedInput-root': { fontSize: 12, height: 30 } }} />
                    <IconButton onClick={() => removeSpecs(index)}>
                      <RemoveCircle sx={{ color: "red" }} />
                    </IconButton>
                  </Stack>}
                </Stack>
              ))}
            </ScrollBox>
          </Box>
          <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
            <Button variant="outlined" onClick={handleCancel} sx={{
              fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
              color: theme.palette.custom.btn, mr: 2,
            }}>CANCEL</Button>
            <Button variant="contained" type="submit"
              sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>CREATE</Button>
          </Box>
        </Stack>}
      </BgBoxOld>
    </form>
  );
};

export default CreateSubCategory;